import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";
import { api } from "../api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id") || sessionStorage.getItem("qrt_session_id");
  const [status, setStatus] = useState("pending");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const maxAttempts = 10;
    const poll = async () => {
      try {
        const r = await api.checkoutStatus(sessionId);
        setData(r);
        if (r.payment_status === "paid" || r.status === "complete") {
          setStatus("paid");
          return;
        }
        if (r.status === "expired" || r.payment_status === "failed") {
          setStatus("failed");
          return;
        }
        if (++attempts < maxAttempts) setTimeout(poll, 1500);
        else setStatus("timeout");
      } catch {
        if (++attempts < maxAttempts) setTimeout(poll, 1500);
        else setStatus("error");
      }
    };
    poll();
  }, [sessionId]);

  function returnToContent() {
    const meta = data?.metadata || {};
    if (meta.artwork_id) navigate(`/opera/${meta.artwork_id}`);
    else if (meta.museum_id) navigate(`/museo/${meta.museum_id}`);
    else navigate("/");
  }

  return (
    <div className="min-h-screen bg-bg flex flex-col items-center justify-center px-6 page-enter">
      {status === "pending" && (
        <>
          <Loader2 className="text-brand animate-spin" size={40} />
          <h1 className="font-heading font-bold text-3xl text-ink text-center mt-6">Stiamo confermando il pagamento…</h1>
          <p className="text-ink-soft text-center mt-2">Solo un attimo, ti porto subito al contenuto sbloccato.</p>
        </>
      )}
      {status === "paid" && (
        <>
          <div className="w-20 h-20 rounded-full bg-emerald-100 flex items-center justify-center mb-4">
            <CheckCircle2 className="text-emerald-500" size={42} />
          </div>
          <h1 className="font-heading font-bold text-4xl text-ink text-center">Pagamento confermato!</h1>
          <p className="text-ink-soft text-center mt-2">Hai sbloccato la storia completa. Buon ascolto.</p>
          <button
            data-testid="payment-success-cta"
            onClick={returnToContent}
            className="mt-8 inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white px-6 py-3 rounded-full font-semibold transition"
          >
            Vai all'opera <ArrowRight size={18} />
          </button>
        </>
      )}
      {(status === "failed" || status === "error" || status === "timeout") && (
        <>
          <h1 className="font-heading font-bold text-3xl text-ink text-center">Pagamento non confermato</h1>
          <p className="text-ink-soft text-center mt-2 max-w-sm">
            Se hai completato il pagamento, ricarica fra qualche secondo. Se hai annullato, puoi riprovare.
          </p>
          <button
            onClick={() => navigate("/")}
            className="mt-6 inline-flex items-center gap-2 bg-brand hover:bg-brand-hover text-white px-6 py-3 rounded-full font-semibold transition"
          >
            Torna alla home
          </button>
        </>
      )}
    </div>
  );
}
